import { Box, Button, DropdownMenu } from '@ksyos/design-system';
import { useTheme } from 'styled-components';
import type { ServiceForSelectedServiceType } from '@common/interfaces/processStartWizard';

type ServiceButtonProps = {
    buttonText: string;
    children?: JSX.Element | JSX.Element[];
    isSelected: boolean;
    onClickService: (service: ServiceForSelectedServiceType) => void;
    service: ServiceForSelectedServiceType;
    serviceOptions: JSX.Element[] | undefined;
};

export function ServiceButton({
    serviceOptions,
    buttonText,
    onClickService,
    service,
    isSelected,
    children,
}: ServiceButtonProps) {
    const theme = useTheme();

    const { code, key, unavailableForPatient: isUnavailableForPatient } = service;
    const disabledStyles = {
        '&:hover': {
            color: theme.colors.neutral500,
            // eslint-disable-next-line sort-keys
            '&:before': {
                background: 'transparent',
            },
        },
    };

    if (serviceOptions) {
        return (
            <DropdownMenu
                trigger={
                    <Button
                        color="secondary"
                        iconRight="caret-down"
                        id={`${code}-${key}`}
                        variant="outline"
                    >
                        {buttonText}
                    </Button>
                }
            >
                {serviceOptions}
            </DropdownMenu>
        );
    } else {
        return (
            <Button
                color="secondary"
                data-automation-test={`start-${code}-${key}`}
                id={`${code}-${key}`}
                isDisabled={isUnavailableForPatient}
                onClick={() => onClickService(service)}
                sx={isUnavailableForPatient && disabledStyles}
                variant={isSelected ? 'solid' : 'outline'}
            >
                <Box sx={{ pointerEvents: 'all' }}>
                    {buttonText}
                    {children}
                </Box>
            </Button>
        );
    }
}
